/* eslint-disable react/prop-types */
import React, { useContext } from "react";
import { EpisodeItem } from "./episode-item";
import { CloseIcon } from "./icons";
import { PlayerContext } from "./player-context";
import { PlayerModal } from "./player-modal";
import "./show-list.m.css";

export function Queue({ handleClose }) {
  const playerContext = useContext(PlayerContext);
  const tracks = playerContext.queue;

  function renderList() {
    return tracks.map(track => (
      <EpisodeItem
        key={track._id}
        podcast={track.podcast}
        episode={track}
        podcastTitle={track.podcast.title}
        inQueueComponent={true}
      />
    ));
  }

  return (
    <PlayerModal label="Your track queue" show={playerContext.currentScreen === "queue"} handleClose={handleClose}>
      <div styleName="show_list">
        <div styleName="show_list_content">
          <div styleName="top_sticky" style={{ display: "flex", justifyContent: "flex-end" }}>
            <button onClick={handleClose} className="pressable" aria-label="Close">
              <CloseIcon width={18} />
            </button>
          </div>
          <header>
            <div styleName="heading heading__list">Queue</div>
          </header>
          {renderList()}
        </div>
      </div>
    </PlayerModal>
  );
}
